// extracted by mini-css-extract-plugin
export default {"wrapper":"FormikTextarea_wrapper__oLU-H","error":"FormikTextarea_error__Gh-wc","input":"FormikTextarea_input__GDvEf","white":"FormikTextarea_white__qL0Pt"};